(function () {
  $('a[rel="lightbox"], a[href*=".jpg"], a[href*=".jpeg"], a[href*=".png"], a[href*=".gif"]').each(function () {
    var $anchor = $(this),
        type = $anchor.data('type') || 'image';

    if ($anchor.is('[download]')) return;

    $anchor.magnificPopup({
      type: type,
      overflowY: 'scroll'
    });
  });

  $.extend(true, $.magnificPopup.defaults, {
    tClose: '&times;',
    tLoading: '…',
    gallery: {
      tPrev: '‹',
      tNext: '›',
      tCounter: '%curr%/%total%'
    },
    image: {
      tError: '<a href="%url%">L’image</a> n’a pas pu être chargée.'
    },
    iframe: {
      tError: '<a href="%url%">Le contenu</a> n’a pas pu être chargé.'
    }
  });
})();
